import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FullSenderName from '../senders/components/FullSenderName';
import { getFromNumber, getFromNumberExt, getToNumber, getToNumberExt, getCallMetadataAttachment
// @ts-expect-error module not typed
} from 'conversations-message-history/call/operators/callMetadataAttachmentGetters';
import formatPhoneNumber from 'I18n/utils/formatPhoneNumber';
// @ts-expect-error module not typed
import formatPhoneNumberWithExtension from 'I18n/utils/formatPhoneNumberWithExtension';
// @ts-expect-error module not typed
import { getDateString } from 'conversations-message-history/util/labelDateUtils';
import senderHeaderPopoverTranslationKeys from '../shared/constants/senderHeaderPopoverTranslationKeys';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import FullRecipientName from '../recipients/components/FullRecipientName';
import { OptionValueType } from './CommonMessageHeaderPopoverList';
import { jsx as _jsx } from "react/jsx-runtime";
export const getCallMessagePopoverContents = ({
  message,
  sender,
  isSenderLoading,
  recipient,
  isRecipientLoading
}) => {
  const callMetadata = getCallMetadataAttachment(message);
  const timestamp = getTimestamp(message);
  const fromNumber = getFromNumber(callMetadata);
  const fromExt = getFromNumberExt(callMetadata);
  const formattedFromNumber = fromExt ? formatPhoneNumberWithExtension(fromNumber, fromExt) : formatPhoneNumber(fromNumber, '');
  const toNumber = getToNumber(callMetadata);
  const toExt = getToNumberExt(callMetadata);
  const formattedToNumber = toExt ? formatPhoneNumberWithExtension(toNumber, toExt) : formatPhoneNumber(toNumber, '');
  return [{
    key: senderHeaderPopoverTranslationKeys.TO,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.common-message.popover.callTo"
    }),
    data: {
      copiableValue: formattedToNumber,
      name: /*#__PURE__*/_jsx(FullRecipientName, {
        recipient: recipient,
        isLoading: isRecipientLoading
      }),
      value: /*#__PURE__*/_jsx("span", {
        children: formattedToNumber
      }),
      valueType: OptionValueType.PhoneNumber
    }
  }, {
    key: senderHeaderPopoverTranslationKeys.FROM,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.common-message.popover.callFrom"
    }),
    data: {
      copiableValue: formattedFromNumber,
      name: /*#__PURE__*/_jsx(FullSenderName, {
        sender: sender,
        isLoading: isSenderLoading
      }),
      value: /*#__PURE__*/_jsx("span", {
        children: formattedFromNumber
      }),
      valueType: OptionValueType.PhoneNumber
    }
  }, {
    key: senderHeaderPopoverTranslationKeys.DATE,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.common-message.popover.date"
    }),
    data: {
      value: /*#__PURE__*/_jsx("span", {
        children: getDateString(I18n.moment(timestamp))
      }),
      valueType: OptionValueType.Date
    }
  }];
};